"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MR_OAUTH_CLIENT_ID = void 0;
const MR_OAUTH_CLIENT_ID = exports.MR_OAUTH_CLIENT_ID = 'dfd7d5b5994048b7b10c06f0fa388d9a';